/**
 * @Author : zhouqinze
 * @Date : 2020-1-3
 * @Version : 1.0
 * @Content : 优驾数字座舱
 **/
<template>
    <div class="youCon">
        <div class="banner">
            <div class="lmtBox" @click="openClick('https://detail.tmall.com/item.htm?id=589654919670')"></div>
            <div class="hudBox" @click="openClick('https://detail.tmall.com/item.htm?spm=a220o.1000855.1998025129.12.469d62bbbr8zrb&pvid=de46962b-f68c-4c0b-b2cb-5d0e1b01a963&pos=12&acm=03054.1003.1.2768562&id=605437273387&scm=1007.16862.95220.23864_0_0&utparam=%7B%22x_hestia_source%22:%2223864%22,%22x_object_type%22:%22item%22,%22x_mt%22:0,%22x_src%22:%2223864%22,%22x_pos%22:12,%22x_pvid%22:%22de46962b-f68c-4c0b-b2cb-5d0e1b01a963%22,%22x_object_id%22:605437273387%7D&sku_properties=122276307:198436662')"></div>
            <div class="lwbBox" @click="openClick('https://detail.tmall.com/item.htm?spm=a220o.1000855.1998025129.2.16181cb1rYAPgz&pvid=2a30312a-59c9-4323-a927-2120c94e4b9f&pos=2&acm=03054.1003.1.2768562&id=605436165871&scm=1007.16862.95220.23864_0_0&utparam=%7B%22x_hestia_source%22:%2223864%22,%22x_object_type%22:%22item%22,%22x_mt%22:0,%22x_src%22:%2223864%22,%22x_pos%22:2,%22x_pvid%22:%222a30312a-59c9-4323-a927-2120c94e4b9f%22,%22x_object_id%22:605436165871%7D&skuId=4415483723083')"></div>
        </div>
            <div class="youShow">
                <div class="content">
                    <div class="showText">
                        <h3>增强式数字座舱&nbsp;&nbsp;由我开始</h3>
                        <p>
                            <span>|</span>
                            <span>|</span>
                        </p>
                    </div>
                    <div class="showBox">
                        <div class="oneBox" @click="openClick('https://detail.tmall.com/item.htm?id=44708040674')"><p>高级版</p></div>
                        <div class="twoBox" @click="openClick('https://detail.tmall.com/item.htm?spm=a220o.1000855.1998025129.2.16181cb1rYAPgz&pvid=2a30312a-59c9-4323-a927-2120c94e4b9f&pos=2&acm=03054.1003.1.2768562&id=605436165871&scm=1007.16862.95220.23864_0_0&utparam=%7B%22x_hestia_source%22:%2223864%22,%22x_object_type%22:%22item%22,%22x_mt%22:0,%22x_src%22:%2223864%22,%22x_pos%22:2,%22x_pvid%22:%222a30312a-59c9-4323-a927-2120c94e4b9f%22,%22x_object_id%22:605436165871%7D&skuId=4415483723083')"><p>联网版</p></div>
                        <div class="thrBox" @click="openClick('https://detail.tmall.com/item.htm?id=45166895562')"><p>胎压监测</p></div>
                        <div class="fouBox" @click="openClick('https://detail.tmall.com/item.htm?spm=a220o.1000855.1998025129.12.469d62bbbr8zrb&pvid=de46962b-f68c-4c0b-b2cb-5d0e1b01a963&pos=12&acm=03054.1003.1.2768562&id=605437273387&scm=1007.16862.95220.23864_0_0&utparam=%7B%22x_hestia_source%22:%2223864%22,%22x_object_type%22:%22item%22,%22x_mt%22:0,%22x_src%22:%2223864%22,%22x_pos%22:12,%22x_pvid%22:%22de46962b-f68c-4c0b-b2cb-5d0e1b01a963%22,%22x_object_id%22:605437273387%7D&sku_properties=122276307:198436662')"><p>HUD抬头显示炫彩版</p></div>
                        <div class="fivBox" @click="openClick('https://detail.tmall.com/item.htm?id=589654919670')"><p>流媒体后视镜</p></div>
                    </div>
                </div>
            </div>
            <div class="youList">
                <div class="listText">
                    <div class="content">
                        <h3 class="youHeader">优驾行业优势</h3>
                        <p class="youTitle">关于优驾，以下主题将帮助您更好地了解</p>
                        <div class="youTab">
                            <div class="tabItem" v-for="(item,index) in tabNormal" :key="index" @click="tabClick(index)">
                                <div class="icon" :style="{backgroundPosition:activeArrCom[index]?tabActive[index]:tabNormal[index][0]}"></div>
                                <!-- <div :src="activeArrCom[index]?tabActive[index]:item[0]"></div> -->
                                <p :style="{color:activeArrCom[index]?'#018CF4':'#000'}">{{item[1]}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list1" v-show="this.list1Show">
                        <span @click="goTurn('lt')">&lt;</span>
                    <div class="content">
                        <div v-for="(item,index) in youList[0].zlzzArr" :key="index" :style="{backgroundImage:'url('+item+')'}"></div>
                    </div>
                        <span @click="goTurn('gt')">&gt;</span>
                </div>
                <div class="listBox" :style="{backgroundImage:youList[activeIndex].img?'url('+youList[activeIndex].img+')':''}" v-show="!this.list1Show">
                    <div class="content">
                        <h3 v-text="youList[activeIndex].title?youList[activeIndex].title:''"></h3>
                        <p v-text="youList[activeIndex].p1?youList[activeIndex].p1:''"></p>
                        <p v-text="youList[activeIndex].p2?youList[activeIndex].p2:''"></p>
                        <p v-text="youList[activeIndex].p3?youList[activeIndex].p3:''"></p>
                        <p v-text="youList[activeIndex].p4?youList[activeIndex].p4:''"></p>
                    </div>
                </div>
            </div>
            <div class="votes">
                <div class="content">
                    <div class="votText">
                        <h3>优驾技术优势</h3>
                        <p>为什么要选择我们的产品</p>
                    </div>
                    <div class="votBox">
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>全球首家六轴<br>传感器OBD盒子</h3>
                            <p>优驾攻克技术难题，将车身姿态解 算芯片内置盒中，实现通过识别车 身姿态判断车主不良驾驶行为</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>全球首款<br>胎压监测系统盒子</h3>
                            <p>历时一年研发，突破传统胎压监测 设备分离与数据不同步问题，将车 况检测和胎压监测集合于同一设备</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>云平台<br>技术</h3>
                            <p>与全球领先的阿里云合作，通过构建 高性能云端数据分析和存储服务， 为用户提供定制化驾驶服务。</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>最早实现<br>蓝牙双连接</h3>
                            <p>最早实现蓝牙2.0和4.0双模连接 支持安卓系统、苹果系统和车机版 安卓系统。</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>AI智能交互</h3>
                            <p>手机车镜数据互联，智能路况播报， 双蓝牙通道，智能语音输入等多种 交互方式，颠覆驾驶体验。</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>深度故障检测</h3>
                            <p>可媲美4S店的车辆故障检测技术， 100＋模块诊断，150＋关键数据报告，保障用车安全。</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>可持续升级</h3>
                            <p>优驾产品可不断升级更新， 实时带给你前沿科技体验。</p>
                        </div>
                        <div class="boxItem">
                            <div class="icon"></div>
                            <h3>大数据分析</h3>
                            <p>凭借出色的大数据分析能力，为车主定制个性化智能保养方案。</p>
                        </div>
                    </div>
                </div>
            </div>
        <div class="bottomImg clearfix">
            <h3>让您的爱车永远驰骋科技前沿</h3>
            <p @click="openClick('http://www.gooddriver.cn/#/')">开启未来</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabNormal:[['-30px -30px','专利资质'],['-202px -30px','团队构造'],['-372px -30px','行业认可'],['-543px -30px','媒体曝光']],
            tabActive:['-30px -200px','-202px -200px','-372px -200px','-543px -200px'],
            activeArr:[true,false,false,false],
            activeIndex:0,
            list1Show:true,
            youList:[
                {
                    zlzzArr:[
                        'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_01.png',
                        'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_02.png',
                        'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_03.png',
                        'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_04.png',
                        'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_05.png'],
                },
                {
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_tdgz_bg.png',
                    title:'团队构造',
                    p1:'产品创始团队集中了交通，汽车，GIS，软硬件研发等各方面的专家，是优驾产品成功的保证。',
                    p2:'研发团队除软硬件开发团队外，还包括与华南理工大学共同成立的“车辆车况检测课题研究组”和“驾驶行为识别及大数据分析课题研究组”，该团队由多个教授，博士，研究生组成，为优驾不断深入发展提供知识储备',
                    p3:'另外，优驾团队还包括汽修专家团队，通过优驾专家向用户提供优质，专属的咨询服务。',
                    p4:''
                },
                {
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_hyrk_bg.png',
                    title:'行业认可',
                    p1:'优驾自推出以来，获得多项行业内荣誉，包括国家级奖项3项，省级奖项4项等',
                    p2:'荣获深圳市汽车电子行业协会颁发的“2016年度汽车电子科学技术优秀创意产品奖”',
                    p3:'荣获2016年由中国通信工业协会，中国工业报社，中国智能终端产业联合会主办的“2016首届中国智能终端大奖”优秀奖',
                    p4:'荣获搜狐汽车“2015年度最佳汽车用品企业”大奖'
                },
                {
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_mtbg_bg.png',
                    title:'媒体曝光',
                    p1:'优驾车载智能OBD胎压版，在使用及功能方面都为车主的驾驶生活提供了极大便捷，是一款实用性非常高的车载智能产品。车主能随时查看爱车车况，透过专业详细的数据分析，更快速地查找车况与胎压异常的源头，可谓是广大车主行车的好伙伴。   ———爱卡汽车网',
                    p2:'优驾推出的创新功能：智能仪表，智能语音及危险变道识别，将新技术带来的方便、安全、经济演绎得淋漓尽致。   ——网易科技',
                    p3:'优驾首家推出了可用手机玩HUD的智能设备，大大降低了HUD的使用门槛。   ——凤凰网优驾在读取数据的同时，还帮助用户在行车过程中优化驾驶习惯，养成安全省油开车的习惯。这是优驾最大的魅力所在。   ——汽车点评网',
                    p4:''
                }
            ]
        }
    },
    methods:{
        tabClick:function(i){
            if(i == 0){
                this.list1Show = true
            }else{
                this.list1Show = false
            }
            this.activeIndex = i
        },
        goTurn(i){
            if(i == 'lt'){
                this.youList[0].zlzzArr.push(this.youList[0].zlzzArr[0])
                this.youList[0].zlzzArr.shift()
            }
            if(i == 'gt'){
                this.youList[0].zlzzArr.unshift(this.youList[0].zlzzArr[4])
                this.youList[0].zlzzArr.pop()
            }
        },
        openClick(item){
            window.open(item)
        }
    },
    computed: {
        activeArrCom:function(){
            let arr = [...this.activeArr]
            for(let index in this.activeArr){
                arr[index] = false
                arr[this.activeIndex] = true
            }
            return arr
        },
    },
}
</script>

<style lang="scss" scoped>
    .youCon{
        width: 100%;
        .banner{
            width: 100%;
            height: 760px;
            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_banner_szzc.png) no-repeat center center;
            background-size: 100% 100%;
            position: relative;
            .lmtBox{
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                width: 28%;
                height: 28%;
                cursor: pointer;
            }
            .hudBox{
                position: absolute;
                left: 25%;
                top: 35%;
                width: 15%;
                height: 20%;
                cursor: pointer;
            }
            .lwbBox{
                position: absolute;
                left: 50%;
                top: 58%;
                transform: translateX(-50%);
                width: 25%;
                height: 32%;
                cursor: pointer;
            }
        }
        // .content{
            .youShow{
                height: 56.9375rem;
                .content{
                    width: 75rem;
                    margin: auto;
                    .showText{
                        color: #333;
                        padding-top: 4.5rem;
                        h3{
                            font-size: 2.625rem;
                            line-height: 2.625rem;
                            margin-bottom: 2.125rem;
                        }
                        p{
                            color: #231815;
                            background: #E9E9E9;
                            width: 3.125rem;
                            height: 3.125rem;
                            padding: 0 .9375rem;
                            box-sizing: border-box;
                            font-weight: bold;
                            font-size: 1.25rem;
                            line-height: 3.125rem;
                            border-radius: 50%;
                            margin: auto;
                            display: flex;
                            justify-content: space-between;
                            span:first-child{
                                transform: rotate(-45deg)
                            }
                            span:last-child{
                                transform: rotate(45deg)
                            }
                            margin-bottom: 3.0625rem;
                        }
                    }
                    .showBox{
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        color: #9D9D9D;
                        div{
                            height: 17.75rem;
                            background: #EEE;
                            font-size: 1.25rem;
                            line-height: 1.25rem;
                            text-align: left;
                            padding-top: 1.1875rem;
                            padding-left: 1.3125rem;
                            box-sizing: border-box;
                            background-repeat: no-repeat;
                        }
                        .oneBox,.thrBox{
                            width: 17.75rem;
                            margin-bottom: 1.1875rem;
                            // box-shadow: 0 0 10px #ccc;
                        }
                        .oneBox{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_gjb.png);
                            background-position: center 5.125rem;
                        }
                        .twoBox{
                            width: 581px;
                            margin-bottom: 19px;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_lwb.png);
                            background-position: center 2.5rem;
                        }
                        .thrBox{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_tyjc.png);
                            background-position: center 4.4375rem;
                        }
                        .fouBox,.fivBox{
                            width: 588px;
                        }
                        .fouBox{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_hud.png);
                            background-position: center 3.5625rem;
                        }
                        .fivBox{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_lmt.png);
                            background-position: center 5.875rem;
                        }
                    }
                }
            }
            .youList{
                width: 100%;
                .listText{
                    height: 23.875rem;
                    background: #E9E9E9;
                    .content{
                        width: 75rem;
                        margin: auto;
                        padding-top: 2.75rem;
                        .youHeader{
                            font-size: 2.625rem;
                            line-height: 2.625rem;
                            margin-bottom: 1.625rem;
                            color: #333;
                        }
                        .youTitle{
                            font-size: 1.375rem;
                            line-height: 1.375rem;
                            color: #aaa;
                            margin-bottom: 4.875rem;
                        }
                        .youTab{
                            display: flex;
                            justify-content: space-between;
                            padding: 0 15%;
                            .tabItem{
                                .icon{
                                    height: 6.5rem;
                                    width: 6.5rem;
                                    display: block;
                                    margin-bottom: 1rem;
                                    background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/szzc_-icon_ys.png);
                                    background-repeat: no-repeat;
                                    // background-position: -30px -30px;
                                }
                                p{
                                    font-size: 1.5rem;
                                    line-height: 1.5rem;
                                }
                            }
                            // .tabItem:nth-child(2){
                            //     .icon{
                            //         background-position: -202px -30px;
                            //     }
                            // }
                            // .tabItem:nth-child(3){
                            //     .icon{
                            //         background-position: -372px -30px;
                            //     }
                            // }
                            // .tabItem:nth-child(4){
                            //     .icon{
                            //         background-position: -543px -30px;
                            //     }
                            // }
                        }
                    }
                }
                .list1{
                    height: 43.875rem;
                    box-sizing: border-box;
                    position: relative;
                    span{
                        font-size: 50px;
                        position: absolute;
                        z-index: 100;
                        display: block;
                        top: 50%;
                        left: 50%;
                        transform: translateY(-50%);
                        color: #aaa;
                        cursor: pointer;
                    }
                    span:nth-child(1){
                        transform: translateX(-34.375rem)
                    }
                    span:last-child{
                        transform: translateX(34.375rem)
                    }
                    .content{
                        width: 75rem;
                        height: 100%;
                        margin: auto;
                        padding: 0 3.125rem;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        position: relative;
                        overflow: hidden;
                        div{
                            width: 23rem;
                            height: 15.75rem;
                            position: absolute;
                            // flex-shrink: 0;
                        }
                        div:nth-child(1){
                            left: 15%;
                            z-index:97;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_01.png);
                            background-repeat:  no-repeat;
                            background-position:  center center;
                            background-size: 100% 60%;
                            transform: translateZ(-6.25rem)
                        }
                        div:nth-child(2){
                            left: 25%;
                            z-index:98;
                            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_02.png);
                            background-repeat:  no-repeat;
                            background-position:  center center;
                            background-size: 100% 80%;
                            transform: translateZ(-3.125rem)
                        }
                        div:nth-child(3){
                            left: 50%;
                            transform: translateX(-50%);
                            z-index:99;
                            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_03.png);
                            background-repeat:  no-repeat;
                            background-position:  center center;
                            background-size: 100% 100%;
                        }
                        div:nth-child(4){
                            right: 25%;
                            z-index:98;
                            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_04.png);
                            background-repeat:  no-repeat;
                            background-position:  center center;
                            background-size: 100% 80%;
                            transform: translateZ(-3.125rem);
                        }
                        div:nth-child(5){
                            right: 15%;
                            z-index:97;
                            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zlzz_05.png);
                            background-repeat:  no-repeat;
                            background-position:  center center;
                            background-size: 100% 60%;
                            transform: translateZ(-6.25rem)
                        }
                        
                    }
                }
                .listBox{
                    width: 100%;
                    height: 43.875rem;
                    box-sizing: border-box;
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    .content{
                        width: 75rem;
                        margin: auto;
                        color: #fff;
                        text-align: left;
                        padding: 9.75rem 3.125rem 0;
                        box-sizing: border-box;
                        h3{
                            width: 8.625rem;
                            border-bottom: .5625rem solid #018CF4;
                            padding-bottom: 1.125rem;
                            font-size: 2.125rem;
                            line-height: 2.125rem;
                            margin-bottom: 1.3125rem;
                        }
                        p{
                            width: 65.5rem;
                            font-size: 1.5rem;
                            // line-height: 24px;
                            margin-bottom: 2.375rem;
                        }
                        p:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .votes{
                padding-top: 4.9375rem;
                .content{
                    width: 75rem;
                    margin: auto;
                    .votText{
                        width: 100%;
                        margin-bottom: 4.3125rem;
                        h3{
                            font-size: 2.625rem;
                            color: #333;
                            line-height: 2.625rem;
                            margin-bottom: 1.6875rem;
                        }
                        p{
                            font-size: 1.375rem;
                            height: 2.125rem;
                            line-height: 2.125rem;
                            color: rgba(102,102,102,1);
                        }
                    }
                    .votBox{
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        margin-bottom: 7.3125rem;
                        .boxItem{
                            width: 18.3125rem;
                            height: 20.375rem;
                            border: 1px solid rgba(220, 220, 220, 1);
                            padding-top: 2rem;
                            box-sizing: border-box;
                            .icon{
                                width: 4.125rem;
                                height: 4.125rem;
                                display: block;
                                margin: auto;
                                margin-bottom: 1.25rem;
                                padding: .125rem;
                                box-sizing: border-box;
                                background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/szzc_icon_jsys.png);
                                background-repeat: no-repeat;
                                background-position: -2rem -1.875rem;
                            }
                            h3{
                                font-size: 1.5rem;
                                // color: #018CF4;
                                box-sizing: border-box;
                                line-height: 1.625rem;
                                margin-bottom: 1.8125rem;
                            }
                            p{
                                text-align: start;
                                text-indent: 2em;
                                width: 15.625rem;
                                margin: auto;
                                font-size: 1rem;
                                color: #333;
                                line-height: 1.625rem;
                            }
                        }
                        .boxItem:nth-child(-n+4){
                            margin-bottom: .625rem;
                        }
                        .boxItem:nth-child(2){
                            .icon{
                                background-position: -10.125rem -1.875rem;
                            }
                        }
                        .boxItem:nth-child(3){
                            .icon{
                                background-position: -18.25rem -1.875rem;
                            }
                        }
                        .boxItem:nth-child(4){
                            .icon{
                                background-position: -26.375rem -1.875rem;
                            }
                        }
                        .boxItem:nth-child(5){
                            .icon{
                                background-position: -2rem -10rem;
                            }
                        }
                        .boxItem:nth-child(6){
                            .icon{
                                background-position: -10.125rem -10rem;
                            }
                        }
                        .boxItem:nth-child(7){
                            .icon{
                                background-position: -18.25rem -10rem;
                            }
                        }
                        .boxItem:nth-child(8){
                            .icon{
                                background-position: -26.375rem -10rem;
                            }
                        }
                        .boxItem:hover{
                            border: .0625rem solid #018CF4;
                            h3{
                                color: #018CF4;
                            }
                        }
                    }
                }
            }
        // }
        .bottomImg{
            width: 100%;
            height: 55.5625rem;
            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_kjqy.png) no-repeat center center;
            background-size: 100% 100%;
            h3{
                margin-top: 12.6875rem;
                margin-bottom: 3.75rem;
                font-size: 4.25rem;
                color: #fff;
                line-height: 4rem;
            }
            p{
                width: 11rem;
                height: 3.5625rem;
                background: #0F63EB;
                border-radius: 1.75rem;
                margin: auto;
                line-height: 3.5625rem;
                font-size: 1.75rem;
                color: #fff;
                cursor: pointer;
            }
        }
    }
</style>